module.exports = __webpack_public_path__ + "media/localization/korean-4a0de68a.png";